import React from 'react';
import PropTypes from 'prop-types';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';

import Styles from './ConfigsListItem.styles';

const BrowserConfigsListItem = ({
  browser,
  browserDisplay,
  browserVersionDisplay,
  device,
  res,
  url,
}) => (
  <div>
    <div className={Styles.url}>{url}</div>
    <div className={Styles.text}>{`${browserDisplay} ${browserVersionDisplay}`}</div>
    <div className={Styles.text}>{device}</div>
    <div className={Styles.text}>{res.split('x').join(' x ')}</div>
    <div className={Styles.icon}>
      <PlatformIcon name={browser} />
    </div>
  </div>
);

BrowserConfigsListItem.propTypes = {
  browser: PropTypes.string.isRequired,
  browserDisplay: PropTypes.string.isRequired,
  browserVersionDisplay: PropTypes.string.isRequired,
  device: PropTypes.string.isRequired,
  res: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default BrowserConfigsListItem;
